export const NOTIFICATIONS_ACTION = 'NOTIFICATIONS_ACTION';
export const NOTIFICATIONS_SUCCESS_ACTION = 'NOTIFICATIONS_SUCCESS_ACTION';
export const NOTIFICATIONS_FAILURE_ACTION = 'NOTIFICATIONS_FAILURE_ACTION';
